import { useEffect } from "react";
import api from "../api";

export function setMetaDescription(content) {
  if (!content) return;
  let m = document.querySelector('meta[name="description"]');
  if (!m) { m = document.createElement("meta"); m.name = "description"; document.head.appendChild(m); }
  m.setAttribute("content", content);
}

// Applies admin SEO overrides for the current path, if any exist.
export function applySeoOverride() {
  const path = window.location.pathname;
  api.get("/seo", { params: { path } }).then(({ data }) => {
    if (data && data.title) document.title = data.title;
    if (data && data.description) setMetaDescription(data.description);
  }).catch(() => {});
}

export default function useSeo(title, description) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) setMetaDescription(description);
    applySeoOverride();
    return () => { document.title = "SimplySitter"; };
  }, [title, description]);
}
